import styled from 'styled-components';

export const DetailShell = styled.div`
  display: grid;
  gap: 12px;
  min-width: 0;
  width: min(100%, 1200px);

  @media (max-width: 639px) {
    gap: 12px;
  }
`;

export const CaseDetailTitleBar = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  min-width: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.lg};
  font-weight: 400;

  strong {
    font-weight: 700;
  }

  .case-detail-back-icon {
    display: none;
  }

  @media (max-width: 639px) {
    gap: 10px;
    margin-bottom: 2px;
    padding-bottom: 10px;
    border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
    font-size: 20px;
    line-height: 1.2;

    > button {
      width: 40px;
      min-width: 40px;
      height: 40px;
      min-height: 40px;
      padding: 0;
    }

    .case-detail-back-label {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .case-detail-back-icon {
      display: block;
      width: 24px;
      height: 24px;
    }

    span {
      min-width: 0;
      overflow-wrap: anywhere;
    }
  }
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 639px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;

    button {
      width: 100%;
      min-width: 0;
      min-height: 38px;
      padding: 7px 10px;
      font-size: 16px;
      line-height: 1.15;
    }
  }
`;

export const NoticeBar = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  border: 1px solid #c7dffb;
  border-radius: ${(p) => p.theme.radii.base};
  background: #edf5fe;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};

  @media (max-width: 768px) {
    grid-template-columns: auto 1fr;

    button {
      grid-column: 2;
      justify-self: start;
    }
  }

  @media (max-width: 639px) {
    gap: 8px;
    padding: 10px 12px;
    font-size: 14px;
    line-height: 1.3;

    button {
      width: min(100%, 172px);
      min-height: 38px;
      padding: 7px 12px;
      font-size: 16px;
    }
  }
`;

export const InfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${(p) => p.theme.colors.info};
  color: ${(p) => p.theme.colors.light};
  font-size: ${(p) => p.theme.fontSizes.xs};
  font-weight: 700;
`;

export const Panel = styled.section`
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  padding: 18px 20px;
  border-radius: ${(p) => p.theme.radii.lg};
  background: ${(p) => p.theme.colors.light};

  @media (max-width: 639px) {
    padding: 20px 12px;
    border-radius: 12px;

    > button {
      width: min(100%, 170px);
      min-height: 40px;
      font-size: 16px;
    }
  }
`;

export const SectionTitle = styled.h3`
  margin: 0 0 14px;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;

  @media (max-width: 639px) {
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.25;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 8px 28px;
  margin-bottom: 18px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: 125px minmax(0, 1fr);
    gap: 8px 12px;
  }

  @media (max-width: 420px) {
    grid-template-columns: 121px minmax(0, 1fr);
    gap: 8px 12px;
  }
`;

export const InfoLabel = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.sm};

  @media (max-width: 639px) {
    font-size: 14px;
    line-height: 1.2;
  }
`;

export const InfoValue = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 600;

  @media (max-width: 639px) {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }
`;

export const BodyText = styled.p`
  margin: 0 0 12px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.45;

  @media (max-width: 639px) {
    margin-bottom: 16px;
    font-size: 16px;
    line-height: 1.45;
  }
`;

export const AppointmentReasonField = styled.label`
  display: grid;
  gap: 6px;
  margin-top: 12px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const AppointmentReasonTextarea = styled.textarea`
  width: 100%;
  min-height: 90px;
  padding: 10px 12px;
  border: 1px solid ${(p) => p.theme.colors.gray100};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.45;
  resize: vertical;

  &::placeholder {
    color: ${(p) => p.theme.colors.gray300};
  }
`;

export const LinkRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 639px) {
    display: grid;
    gap: 14px;
  }
`;

export const TextLink = styled.a`
  color: ${(p) => p.theme.colors.primary300};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
  text-decoration: underline;

  @media (max-width: 639px) {
    width: fit-content;
    font-size: 16px;
    line-height: 1.25;
  }
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 9px 12px;
    border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
    text-align: left;
    color: ${(p) => p.theme.colors.gray500};
    font-size: ${(p) => p.theme.fontSizes.sm};
    vertical-align: middle;
  }

  th {
    color: ${(p) => p.theme.colors.gray300};
    font-weight: 400;
  }
`;

export const MeetingDataTable = styled(DataTable)`
  table-layout: fixed;
`;

export const MeetingNameRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

export const MeetingEndedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 8px;
  border-radius: ${(p) => p.theme.radii.sm};
  background: ${(p) => p.theme.colors.gray100};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.xs};
  font-weight: 700;
  line-height: 1;
`;

export const TableScroll = styled.div`
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-inline: contain;

  ${DataTable} {
    min-width: 680px;
  }
`;

export const DocumentTableScroll = styled(TableScroll)`
  table {
    table-layout: fixed;
  }

  .pbl-document-name-column {
    width: 40%;
    max-width: 40%;
  }

  td.pbl-document-name-column {
    overflow: hidden;
  }
`;

export const TableActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

export const MobileRecords = styled.div`
  display: grid;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};
`;

export const MobileRecord = styled.div`
  display: grid;
  grid-template-columns: 121px minmax(0, 1fr);
  gap: 8px 12px;
  padding: 18px 4px;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
  background: ${(p) => p.theme.colors.gray000};
`;

export const MobileRecordLabel = styled.div`
  color: ${(p) => p.theme.colors.gray300};
  font-size: 14px;
  line-height: 1.2;
`;

export const MobileRecordValue = styled.div`
  min-width: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: 14px;
  line-height: 1.25;
  overflow-wrap: anywhere;

  ${TableActions} {
    justify-content: stretch;
  }

  button {
    width: 100%;
    min-height: 30px;
    padding: 4px 10px;
    font-size: 14px;
    line-height: 1.15;
  }
`;

export const MobileEmptyRecord = styled.div`
  padding: 18px 4px;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};
  border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
  color: ${(p) => p.theme.colors.gray300};
  font-size: 14px;
  text-align: center;
`;

export const MobileSearchInput = styled.input`
  width: 100%;
  height: 32px;
  margin-bottom: 16px;
  padding: 0 34px 0 10px;
  border: 1px solid ${(p) => p.theme.colors.primary200};
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => p.theme.colors.light} url('/images/event/search.svg') right 8px center / 18px 18px no-repeat;
  color: ${(p) => p.theme.colors.gray500};
  font-size: 14px;

  &::placeholder {
    color: ${(p) => p.theme.colors.gray300};
  }
`;

export const DocumentUploadArea = styled.div`
  margin-bottom: 10px;

  @media (max-width: 639px) {
    > div:first-child {
      display: block;
      padding: 14px 12px;
      margin-bottom: 14px;
      border-radius: 12px;
    }

    > div:first-child > p {
      display: none;
    }

    > div:first-child label,
    > div:first-child label > * {
      display: block;
      width: 100%;
    }

    > p {
      margin: 0 0 16px;
      color: ${(p) => p.theme.colors.gray300};
      font-size: 16px;
      line-height: 1.45;
      text-align: left;
    }
  }
`;

export const MobilePagination = styled.div`
  display: grid;
  justify-items: center;
  gap: 10px;
  margin-top: 16px;
  color: ${(p) => p.theme.colors.gray300};
  font-size: 14px;
  text-align: center;
`;

export const MobilePaginationDisplay = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(p) => p.theme.colors.gray500};

  select {
    height: 32px;
    padding: 0 26px 0 8px;
    border: 1px solid ${(p) => p.theme.colors.primary200};
    border-radius: ${(p) => p.theme.radii.base};
    background: ${(p) => p.theme.colors.light};
    color: ${(p) => p.theme.colors.gray500};
    font-size: 14px;
  }
`;

export const MobilePageButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const MobilePageButton = styled.button<{ $active?: boolean }>`
  min-width: 34px;
  height: 30px;
  padding: 0 8px;
  border: 0;
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => (p.$active ? p.theme.colors.primary300 : p.theme.colors.gray100)};
  color: ${(p) => (p.$active ? p.theme.colors.light : p.theme.colors.gray500)};
  font-size: 14px;
  cursor: pointer;

  &:disabled {
    color: ${(p) => p.theme.colors.gray300};
    cursor: default;
  }
`;

export const IconActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.primary500};
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }

  path {
    fill: currentColor;
  }

  &:disabled {
    color: ${(p) => p.theme.colors.gray300};
    cursor: default;
    opacity: 0.7;
  }
`;

export const TableFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.xs};
`;

export const PaginationRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

export const PageButton = styled.button<{ active?: boolean }>`
  min-width: 24px;
  height: 22px;
  padding: 0 6px;
  border: 1px solid ${(p) => (p.active ? p.theme.colors.primary500 : p.theme.colors.gray100)};
  border-radius: ${(p) => p.theme.radii.sm};
  background: ${(p) => (p.active ? p.theme.colors.light : p.theme.colors.gray000)};
  color: ${(p) => (p.active ? p.theme.colors.primary500 : p.theme.colors.gray300)};
  font-size: ${(p) => p.theme.fontSizes.xs};
`;

export const PageInput = styled.input`
  width: 34px;
  height: 22px;
  border: 1px solid ${(p) => p.theme.colors.primary100};
  border-radius: ${(p) => p.theme.radii.sm};
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.xs};
  text-align: center;
`;

export const SmallButton = styled.button<{ tone?: 'blue' | 'green' | 'orange' | 'plain' }>`
  min-height: 26px;
  padding: 3px 10px;
  border: 0;
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) =>
    p.tone === 'green'
      ? p.theme.colors.secondary500
      : p.tone === 'orange'
      ? p.theme.colors.orange
      : p.tone === 'plain'
      ? 'transparent'
      : p.theme.colors.primary500};
  color: ${(p) => (p.tone === 'plain' ? p.theme.colors.primary500 : p.theme.colors.light)};
  font-size: ${(p) => p.theme.fontSizes.xs};
  cursor: pointer;
`;

export const SearchRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
`;

export const SearchInput = styled.input`
  width: min(190px, 100%);
  height: 28px;
  padding: 0 10px;
  border: 1px solid ${(p) => p.theme.colors.primary100};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.xs};
`;

export const FileName = styled.div`
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  gap: 2px 7px;
  min-width: 0;
  max-width: 100%;
`;

export const FileIcon = styled.span`
  grid-row: 1 / span 3;
  display: inline-flex;
  width: 12px;
  height: 12px;
  margin-top: 3px;
  border-radius: 50%;
  background: ${(p) => p.theme.colors.danger};
`;

export const FileMeta = styled.span`
  grid-column: 2;
  min-width: 0;
  overflow: hidden;
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.xs};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileNameText = styled.span`
  grid-column: 2;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const VerifyLink = styled.a`
  grid-column: 2;
  width: fit-content;
  max-width: 100%;
  color: ${(p) => p.theme.colors.secondary500};
  font-size: ${(p) => p.theme.fontSizes.xs};
  overflow-wrap: anywhere;
  text-decoration: underline;
`;

export const BulletList = styled.ul`
  margin: 0 0 12px;
  padding-left: 20px;
  list-style: disc outside;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.45;

  @media (max-width: 639px) {
    margin-bottom: 18px;
    padding-left: 26px;
    font-size: 16px;
    line-height: 1.45;
  }
`;

export const TypeText = styled.span`
  color: ${(p) => p.theme.colors.danger};
  font-weight: 700;
`;

export const StatusDot = styled.span<{ accepted?: boolean }>`
  display: inline-flex;
  width: 14px;
  height: 14px;
  border: 2px solid ${(p) => (p.accepted ? p.theme.colors.secondary500 : p.theme.colors.gray100)};
  border-radius: 50%;
  background: ${(p) => (p.accepted ? p.theme.colors.secondary500 : p.theme.colors.light)};
`;

export const SignGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 350px) minmax(0, 780px);
  gap: 30px;
  margin-bottom: 30px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SignColumnTitle = styled.div`
  padding: 10px 8px;
  background: ${(p) => p.theme.colors.gray000};
  color: ${(p) => p.theme.colors.gray500};
  font-weight: 700;
  text-align: center;
`;

export const SignInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 8px 12px;
  margin-top: 12px;
`;

export const SignatureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SignatureBox = styled.div`
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  gap: 12px 10px;
  align-items: center;
`;

export const SignedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 180px;
  height: 100px;
  border-radius: 5px;
  background: ${(p) => p.theme.colors.gray300};
  color: ${(p) => p.theme.colors.light};
  font-weight: 700;
`;

export const SignButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 180px;
  height: 100px;
  border: 0;
  border-radius: 5px;
  background: ${(p) => p.theme.colors.warning};
  color: ${(p) => p.theme.colors.gray500};
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
`;

export const FooterAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 18px;

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const FooterTextButton = styled.button`
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.md};
  text-decoration: underline;
  cursor: pointer;
`;

export const ModalSurface = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: min(92vw, 540px);
  max-height: 88vh;
  padding: 25px;
  border-radius: 40px 40px 40px 0;
  background: ${(p) => p.theme.colors.light};
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
`;

export const ModalCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.gray400};
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ReviewSummaryModalSurface = styled(ModalSurface)`
  width: min(930px, calc(100vw - 32px));
  max-height: calc(100vh - 56px);
  padding: 30px 52px 28px;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 28px 24px;
  }
`;

export const ReviewSummaryModalScroll = styled.div`
  max-height: calc(100vh - 122px);
  overflow-y: auto;
  padding-right: 10px;
  scrollbar-gutter: stable;
`;

export const ReviewSummaryModalCloseButton = styled(ModalCloseButton)`
  position: absolute;
  top: 14px;
  right: 14px;
`;

export const ModalNotice = styled.p`
  margin: 0 0 18px;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.5;
`;

export const ModalFieldStack = styled.div`
  display: grid;
  gap: 14px;
`;

export const ModalLabel = styled.label`
  display: grid;
  gap: 6px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const ModalInput = styled.input`
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1px solid ${(p) => p.theme.colors.gray100};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const ModalTextarea = styled.textarea`
  width: 100%;
  min-height: 84px;
  padding: 10px 12px;
  border: 1px solid ${(p) => p.theme.colors.gray100};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.45;
  resize: vertical;
`;

export const ModalSelect = styled.select`
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1px solid ${(p) => p.theme.colors.gray100};
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => p.theme.colors.light};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const FilePickerLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 46px;
  padding: 10px 12px;
  border: 1px solid ${(p) => p.theme.colors.primary100};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  cursor: pointer;
  position: relative;

  span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  svg {
    position: absolute;
    right: 12px;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const ModalActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 28px;
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 8px 16px;
  margin-top: 8px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 4px;
  }
`;

export const DetailLabel = styled.div`
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const DetailValue = styled.div`
  min-width: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  overflow-wrap: anywhere;
`;

export const ResultIcon = styled.div<{ success?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  margin: 12px auto;
  border-radius: 50%;
  color: ${(p) => (p.success ? p.theme.colors.secondary500 : p.theme.colors.danger)};

  svg {
    width: 46px;
    height: 46px;
  }

  path {
    fill: currentColor;
  }
`;

export const ResolutionButton = styled.button<{ variantStyle?: 'primary' | 'white' }>`
  display: block;
  width: 100%;
  min-height: 58px;
  padding: 16px;
  border: 1px solid ${(p) => p.theme.colors.primary500};
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => (p.variantStyle === 'primary' ? p.theme.colors.primary500 : p.theme.colors.light)};
  color: ${(p) => (p.variantStyle === 'primary' ? p.theme.colors.light : p.theme.colors.gray500)};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
  text-align: center;
  cursor: ${(p) => (p.variantStyle === 'primary' ? 'pointer' : 'default')};

  &:disabled {
    cursor: default;
    opacity: 0.9;
  }
`;

export const Triangle = styled.div`
  width: 0;
  height: 0;
  margin: 10px auto;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 14px solid ${(p) => p.theme.colors.primary500};
`;
